<template lang="pug">
  div
    div(style="font-size:20px;font-weight:bold")
      span {{opts.title}}
      el-button(type="primary" size="mini" @click='confirm' style="float:right;margin-right:5px") 确定
    el-table.cl-table(:data="tableData" border style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange")
      el-table-column(type="selection")
      el-table-column(v-for="l,p in tableHead" :prop="p" :label="l" :key="p")
        template(slot-scope="scope")
          a(:title="'筛选'+scope.row.label" @click="click(scope.row.label)") {{ scope.row[p] }}

</template>
<script>
// Generated by CoffeeScript 2.3.0
export default {
  name: 'Pie',
  chart: null,
  props: {
    opts: Object,
  },
  data() {
    return {
      tableData: [],
      tableHead: {
        label: '内容',
      },
      multipleSelection: [],
    }
  },
  mounted() {
    return this.render()
  },
  methods: {
    load() {
      return this.opts.load().then(
        data =>
          (this.tableData = data.map((d, k) => {
            d.label = d.name = d._id
            return d
          })),
      )
    },
    clickOnNull() {
      if (this.opts.clickOnNull) {
        return this.opts.clickOnNull()
      }
    },
    click(v) {
      let base
      if (typeof (base = this.opts).click === 'function') {
        base.click(v)
      }
      return this.$parent.doClose()
    },
    render() {
      return this.load().then(data => {})
    },
    // toggleSelection: (rows) ->
    //   if rows
    //     rows.forEach (row) =>
    //       @$refs.multipleTable.toggleRowSelection(row)
    //   else
    //     @$refs.multipleTable.clearSelection()
    handleSelectionChange(val) {
      return (this.multipleSelection = val)
    },
    confirm() {
      let arr, base, v
      arr = this.multipleSelection.map(m => m.label)
      v = arr.join('/')
      if (typeof (base = this.opts).click === 'function') {
        base.click(v)
      }
      return this.$parent.doClose()
    },
  },
}
</script>

